<template>
  <div>
    <PersonnelWorkHistory/>
  </div>
</template>

<script>
import PersonnelWorkHistory from '../../components/personnelWorkHistory.vue';

export default {
    name: 'HRvecPersonnelWorkHistory',
    data() {
        return {};
    },
    mounted() {
    },
    methods: {},
    components: { PersonnelWorkHistory }
};
</script>

<style lang="scss" scoped>

</style>